// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d06254a69a8ebbfb58e1","131":"4401495e8418b941ee2f","132":"f9ed9cf4eea42745f0f0","170":"e1e0c2175448332e4af2"}[chunkId] + ".chunk.js";
};